import React, { useState } from "react";
import { Link } from "react-router-dom";

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <>
      {/* Preloader */}
      <div id="preloader">
        <div id="ctn-preloader" className="ctn-preloader">
          <div className="animation-preloader">
            <div className="spinner" />
            <img
              src="/static/img/logo/head%20logo.webp"
              alt="logo"
              style={{ width: "300px", height: "auto" }}
            />
          </div>
          <div className="loader">
            <div className="row">
              <div className="col-3 loader-section section-left"><div className="bg" /></div>
              <div className="col-3 loader-section section-left"><div className="bg" /></div>
              <div className="col-3 loader-section section-right"><div className="bg" /></div>
              <div className="col-3 loader-section section-right"><div className="bg" /></div>
            </div>
          </div>
        </div>
      </div>

      {/* Header */}
      <header className="header-area-3 stiky">
        <div className="container header-3">
          <div className="row align-items-center">
            {/* Logo */}
            <div className="col-xl-3 col-lg col-md-6 col-6">
              <div className="ca-logo">
                <a href="https://karmyogienterprise.com/">
                  <img src="static/img/logo/head logo.webp" alt="Logo" />
                </a>
              </div>
            </div>

            {/* Main Menu (Desktop) */}
            <div className="col-xl-6 col-lg-7 d-none d-lg-block">
              <div className="ca-main-menu-3">
                <nav className="ca-mobile-menu-active-3">
                  <ul>
                    <li><Link to="/">Home</Link></li>
                    <li><Link to="/about">About Us</Link></li>
                    {/* <li><Link to="/blog">Blog</Link></li> */}
                    <li><Link to="/products">Products</Link></li>
                    <li><Link to="/contact">Contact</Link></li>
                  </ul>
                </nav>
              </div>
            </div>

            {/* Header Action */}
            <div className="col-xl-3 col-lg col-md-6 col-6">
              {/* Get a Quote button (Desktop) */}
              <div className="ca-btn-header d-none d-lg-block text-end">
                <a
                  href="/contact"
                  className="ca-btn-primary-3 theme-bg-3 text-white br-50 "
                >
                  Get A Quote
                  <span><i className="fa-solid fa-angle-right" /></span>
                </a>
              </div>

              {/* Mobile menu toggle */}
              <div className="ca-header-action-item d-lg-none text-end">
                <button
                  type="button"
                  className="ca-offcanvas-toggle"
                  onClick={toggleMenu}
                >
                  <svg width={30} height={16} viewBox="0 0 30 16">
                    <rect x={10} width={20} height={2} fill="currentColor" />
                    <rect x={5} y={7} width={25} height={2} fill="currentColor" />
                    <rect x={10} y={14} width={20} height={2} fill="currentColor" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Off-canvas Menu */}
      <div className={`ca-offcanvas w-bg ${menuOpen ? "ca-offcanvas-open" : ""}`}>
        <div className="ca-offcanvas-wrapper">
          <div className="ca-offcanvas-header d-flex justify-content-between align-items-center mb-40 toggle-mb">
            <div className="ca-offcanvas-logo">
              <a href="#">
                <img src="static/img/logo/head logo.webp" alt="Logo" />
              </a>
            </div>
            <button className="ca-offcanvas-close-toggle" onClick={toggleMenu}>
              <i className="fal fa-times" />
            </button>
          </div>

          {/* Mobile Menu Links */}
          <div className="ca-offcanvas-menu-3 mb-40 head-mb">
            <nav>
              <ul>
                <li><Link to="/" onClick={toggleMenu}>Home</Link></li>
                <li><Link to="/about" onClick={toggleMenu}>About Us</Link></li>
                {/* <li><Link to="/blog" onClick={toggleMenu}>Blog</Link></li> */}
                <li><Link to="/products" onClick={toggleMenu}>Products</Link></li>
                <li><Link to="/contact" onClick={toggleMenu}>Contact</Link></li>
              </ul>
            </nav>
          </div>

          {/* Mobile CTA */}
          <div className="ca-offcanvas-contact mb-40 head-mb gaq-n">
            <a href="/contact" className="ca-btn-primary-3 theme-bg-3 text-white br-50">
              Get A Quote
              <span><i className="fa-solid fa-angle-right" /></span>
            </a>
          </div>

          {/* Contact Info */}
          <div className="ca-offcanvas-contact-info mb-40">
            <h3 className="ca-offcanvas-sm-title">Contact Info</h3>

            <div className="ca-sm-single-item-4 ca-sm-single-item-1 mb-20 con-in">
              <div className="icon"><span><i className="fa-solid fa-location-dot" /></span></div>
              <div className="ca-sm-single-item-4-content">
                <p><a href="#">91 Shubham Industrial Estate ,Puna-Valthan Road, Surat</a></p>
              </div>
            </div>

            <div className="ca-sm-single-item-4 ca-sm-single-item-1 mb-20 con-in">
              <div className="icon"><span><i className="fa-solid fa-phone" /></span></div>
              <div className="ca-sm-single-item-4-content">
                <p><a href="tel:+916352099433">+91 6352099433</a></p>
              </div>
            </div>

            <div className="ca-sm-single-item-4 ca-sm-single-item-1 mb-20 con-in">
              <div className="icon"><span><i className="fa-solid fa-envelope" /></span></div>
              <div className="ca-sm-single-item-4-content">
                <p><a href="mailto:tarak@karmyogienterprise.com">tarak@karmyogienterprise.com</a></p>
              </div>
            </div>
          </div>

          {/* Social Links */}
          <div className="ca-offcanvas-social mb-40">
            <h3 className="ca-offcanvas-sm-title">Follow Us</h3>
            <div className="ca-footer-social ca-footer-social-3">
              <ul>
                <li><a href="#"><i className="fa-brands fa-instagram" /></a></li>
                <li><a href="#"><i className="fa-brands fa-facebook-f" /></a></li>
                <li><a href="#"><i className="fa-brands fa-linkedin-in" /></a></li>
                <li><a href="#"><i className="fa-brands fa-x-twitter" /></a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Overlay */}
      {menuOpen && <div className="ca-offcanvas-overlay" onClick={toggleMenu} />}
    </>
  );
}

export default Header;
